/**
 * @description - Check form fields, disable default invallid handling + add our own
 *
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 * @param {Object} inputs - inputs object to be checked
 */

const inputErrorClassName = 'error';
const allInputs = document.querySelectorAll('input, select, textarea, checkbox, radio');

function checkFormFields(inputs) {
    inputs.forEach((input) => {
        input.setCustomValidity('');
        // Add class on submit when input invalid.
        input.addEventListener('invalid', (event) => {
            event.preventDefault();
            input.classList.add(inputErrorClassName);
        });

        // Remove class when input becomes valid
        // event 'input' will fire each time the user types
        input.addEventListener('input', () => {
            if (input.validity.valid) {
                input.classList.remove(inputErrorClassName);
            }
        });
    });
}

if (allInputs.length) {
    checkFormFields(allInputs);
}
